// CRITICAL: Business requirement is 1,536 hours/FTE/year exactly
// This calculation must match database requirements and audited Excel templates
export const TIME_CONFIG = {
  HOURS_PER_FTE_YEAR: 1536, // Authoritative formula: FTEs × Automation % × 1,536 hours/FTE/year
  // Legacy breakdown (for reference only - use HOURS_PER_FTE_YEAR for all calculations)
  WORKDAYS_PER_MONTH: 16,
  HOURS_PER_DAY: 8,
  MONTHS_PER_YEAR: 12,
};